import React from 'react';
import { Eye } from 'lucide-react';
import { GERRY_AVATAR, CONCEPT_IMAGES, detectConcept } from './gerryConstants';

export const GerryMessageList = ({ messages, expandedImages, setExpandedImages, messagesEndRef }) => (
  <div className="h-72 overflow-y-auto px-3 py-3 space-y-3 scrollbar-thin" data-testid="gerry-messages">
    {messages.map((m, i) => {
      const concept = m.role === 'gerry' ? detectConcept(m.text) : null;
      const isExpanded = expandedImages.has(i);
      const msgKey = `${m.role}-${m.ts || i}`;

      return (
        <div key={msgKey} className={`flex gap-2 ${m.role === 'user' ? 'flex-row-reverse' : ''}`}>
          {m.role === 'gerry' && <img src={GERRY_AVATAR} alt="G" className="w-5 h-5 rounded-full object-cover flex-shrink-0 mt-0.5" />}
          <div className="max-w-[85%]">
            <div
              className={`px-3 py-2 rounded-2xl text-sm leading-relaxed ${
                m.role === 'user'
                  ? 'bg-cyan-600/30 text-cyan-100 rounded-br-md'
                  : 'bg-orange-900/30 text-orange-100 border border-orange-500/20 rounded-bl-md'
              }`}
            >
              {m.text}
            </div>
            {m.game && m.game !== 'hub' && (
              <p className="text-[9px] text-gray-500 mt-0.5 px-1">from {m.game}</p>
            )}
            {concept && CONCEPT_IMAGES[concept] && (
              <button
                onClick={() => setExpandedImages(prev => {
                  const next = new Set(prev);
                  next.has(i) ? next.delete(i) : next.add(i);
                  return next;
                })}
                className="mt-1.5 inline-flex items-center gap-1 px-2.5 py-1 rounded-full text-[10px] font-bold bg-purple-500/20 text-purple-300 border border-purple-500/30 hover:bg-purple-500/30 transition-all"
                data-testid={`show-concept-${concept}`}
              >
                <Eye className="w-3 h-3" />
                {isExpanded ? 'Hide image' : `Show me: ${CONCEPT_IMAGES[concept].label}`}
              </button>
            )}
            {concept && isExpanded && CONCEPT_IMAGES[concept] && (
              <div className="mt-2 rounded-xl overflow-hidden border border-purple-500/30 shadow-lg shadow-purple-500/10">
                <img src={CONCEPT_IMAGES[concept].url} alt={CONCEPT_IMAGES[concept].label} className="w-full h-auto" loading="lazy" />
                <p className="text-[10px] text-center py-1.5 text-purple-300 bg-gray-900/80 font-bold">
                  {CONCEPT_IMAGES[concept].label}
                </p>
              </div>
            )}
          </div>
        </div>
      );
    })}
    <div ref={messagesEndRef} />
  </div>
);
